import React from "react";
import PageHero from "../components/PageHero";
import Careers from "../components/Careers";
import Industries from "../components/Industries";
import Testimonials from "../components/Testimonials";
import { IMAGES } from "../config/siteConfig";

export default function JobSeekers() {
  return (
    <>
      <PageHero
        label="Careers"
        title="Build products that"
        highlight="go live worldwide."
        subtitle="Join INRISOFT and help deliver software across Healthcare, Education, Logistics, Fintech and more — with teams spanning UAE, India and Latin America."
        image={IMAGES.jobseekers}
      />
      <Careers />
      <Industries />
      <Testimonials />
    </>
  );
}
